function getContadores() {
    if (localStorage.getItem('dispositivos') === 'B827EB7BE480,B827EB7BE482') {
        return contadoresData
    } else {
        return contadoresDos
    }
}

const contadoresDos = [
    {
        "id": 5,
        "nombre": "Contador Almendros",
        "n_pulsos": 9958,
        "caudal": 0,
        "fecha_registro": "2024-04-11T11:41:08.000Z",
        "latitud": 39.864658,
        "longitud": -1.357314,
        "id_remote": "011B06",
        "nombre_remote": "Remote Lite Almendros",
        "battery_level": 3965,
        "battery_timestamp": "2023-10-02 13:55:40",
        "real_value": 11.4,
        "historico": {
            "fecha_registro": [
                "2024-01-02 00:00:00",
                "2024-01-02 01:00:00",
                "2024-01-02 02:00:00",
                "2024-01-02 03:00:00",
                "2024-01-02 04:00:00",
                "2024-01-02 05:00:00",
                "2024-01-02 06:00:00",
                "2024-01-02 07:00:00",
                "2024-01-02 08:00:00",
                "2024-01-02 09:00:00",
                "2024-01-02 10:00:00",
                "2024-01-02 11:00:00",
                "2024-01-02 12:00:00",
                "2024-01-02 13:00:00",
                "2024-01-02 14:00:00",
                "2024-01-02 15:00:00",
                "2024-01-02 16:00:00",
                "2024-01-02 17:00:00",
                "2024-01-02 18:00:00",
                "2024-01-02 19:00:00",
                "2024-01-02 20:00:00",
                "2024-01-02 21:00:00",
                "2024-01-02 22:00:00",
                "2024-01-02 23:00:00",
                "2024-01-03 00:00:00",
                "2024-01-03 01:00:00",
                "2024-01-03 02:00:00",
                "2024-01-03 03:00:00",
                "2024-01-03 04:00:00",
                "2024-01-03 05:00:00",
                "2024-01-03 06:00:00",
                "2024-01-03 07:00:00",
                "2024-01-03 08:00:00",
                "2024-01-03 09:00:00",
                "2024-01-03 10:00:00",
                "2024-01-03 11:00:00",
                "2024-01-03 12:00:00",
                "2024-01-03 13:00:00",
                "2024-01-03 14:00:00",
                "2024-01-03 15:00:00",
                "2024-01-03 16:00:00",
                "2024-01-03 17:00:00",
                "2024-01-03 18:00:00",
                "2024-01-03 19:00:00",
                "2024-01-03 20:00:00",
                "2024-01-03 21:00:00",
                "2024-01-03 22:00:00",
                "2024-01-03 23:00:00",
                "2024-01-04 00:00:00",
                "2024-01-04 01:00:00",
                "2024-01-04 02:00:00",
                "2024-01-04 03:00:00",
                "2024-01-04 04:00:00",
                "2024-01-04 05:00:00",
                "2024-01-04 06:00:00",
                "2024-01-04 07:00:00",
                "2024-01-04 08:00:00",
                "2024-01-04 09:00:00",
                "2024-01-04 10:00:00",
                "2024-01-04 11:00:00",
                "2024-01-04 12:00:00",
                "2024-01-04 13:00:00",
                "2024-01-04 14:00:00",
                "2024-01-04 15:00:00",
                "2024-01-04 16:00:00",
                "2024-01-04 17:00:00",
                "2024-01-04 18:00:00",
                "2024-01-04 19:00:00",
                "2024-01-04 20:00:00",
                "2024-01-04 21:00:00",
                "2024-01-04 22:00:00",
                "2024-01-04 23:00:00",
                "2024-01-05 00:00:00",
                "2024-01-05 01:00:00",
                "2024-01-05 02:00:00",
                "2024-01-05 03:00:00",
                "2024-01-05 04:00:00",
                "2024-01-05 05:00:00",
                "2024-01-05 06:00:00",
                "2024-01-05 07:00:00",
                "2024-01-05 08:00:00",
                "2024-01-05 09:00:00",
                "2024-01-05 10:00:00",
                "2024-01-05 11:00:00",
                "2024-01-05 12:00:00",
                "2024-01-05 13:00:00",
                "2024-01-05 14:00:00",
                "2024-01-05 15:00:00",
                "2024-01-05 16:00:00",
                "2024-01-05 17:00:00",
                "2024-01-05 18:00:00",
                "2024-01-05 19:00:00",
                "2024-01-05 20:00:00",
                "2024-01-05 21:00:00",
                "2024-01-05 22:00:00",
                "2024-01-05 23:00:00",
                "2024-01-06 00:00:00",
                "2024-01-06 01:00:00",
                "2024-01-06 02:00:00",
                "2024-01-06 03:00:00",
                "2024-01-06 04:00:00",
                "2024-01-06 05:00:00",
                "2024-01-06 06:00:00",
                "2024-01-06 07:00:00",
                "2024-01-06 08:00:00",
                "2024-01-06 09:00:00",
                "2024-01-06 10:00:00",
                "2024-01-06 11:00:00",
                "2024-01-06 12:00:00",
                "2024-01-06 13:00:00",
                "2024-01-06 14:00:00",
                "2024-01-06 15:00:00",
                "2024-01-06 16:00:00",
                "2024-01-06 17:00:00",
                "2024-01-06 18:00:00",
                "2024-01-06 19:00:00",
                "2024-01-06 20:00:00",
                "2024-01-06 21:00:00",
                "2024-01-06 22:00:00",
                "2024-01-06 23:00:00",
                "2024-01-07 00:00:00",
                "2024-01-07 01:00:00",
                "2024-01-07 02:00:00",
                "2024-01-07 03:00:00",
                "2024-01-07 04:00:00",
                "2024-01-07 05:00:00",
                "2024-01-07 06:00:00",
                "2024-01-07 07:00:00",
                "2024-01-07 08:00:00",
                "2024-01-07 09:00:00",
                "2024-01-07 10:00:00",
                "2024-01-07 11:00:00",
                "2024-01-07 12:00:00",
                "2024-01-07 13:00:00",
                "2024-01-07 14:00:00",
                "2024-01-07 15:00:00",
                "2024-01-07 16:00:00",
                "2024-01-07 17:00:00",
                "2024-01-07 18:00:00",
                "2024-01-07 19:00:00",
                "2024-01-07 20:00:00",
                "2024-01-07 21:00:00",
                "2024-01-07 22:00:00",
                "2024-01-07 23:00:00",
                "2024-01-08 00:00:00",
                "2024-01-08 01:00:00",
                "2024-01-08 02:00:00",
                "2024-01-08 03:00:00",
                "2024-01-08 04:00:00",
                "2024-01-08 05:00:00",
                "2024-01-08 06:00:00",
                "2024-01-08 07:00:00",
                "2024-01-08 08:00:00",
                "2024-01-08 09:00:00",
                "2024-01-08 10:00:00",
                "2024-01-08 11:00:00",
                "2024-01-08 12:00:00",
                "2024-01-08 13:00:00",
                "2024-01-08 14:00:00",
                "2024-01-08 15:00:00",
                "2024-01-08 16:00:00",
                "2024-01-08 17:00:00",
                "2024-01-08 18:00:00",
                "2024-01-08 19:00:00",
                "2024-01-08 20:00:00",
                "2024-01-08 21:00:00",
                "2024-01-08 22:00:00",
                "2024-01-08 23:00:00",
                "2024-01-09 00:00:00",
                "2024-01-09 01:00:00",
                "2024-01-09 02:00:00",
                "2024-01-09 03:00:00",
                "2024-01-09 04:00:00",
                "2024-01-09 05:00:00",
                "2024-01-09 06:00:00",
                "2024-01-09 07:00:00",
                "2024-01-09 08:00:00",
                "2024-01-09 09:00:00",
                "2024-01-09 10:00:00",
                "2024-01-09 11:00:00"
            ],
            "caudal": [
                0.8, 0.9, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                4.1, 4.3, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9, 6.1, 6.3, 6.5, 6.7, 6.9,
                4.1, 4.3, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9, 6.1, 6.3, 6.5, 6.7, 6.9,
                7.1, 7.3, 7.5, 7.7, 7.9, 8.1, 8.3, 8.5, 8.7, 8.9, 9.1, 9.3, 9.5, 9.7, 9.9, 10.1,
                10.3, 10.5, 10.7, 10.9, 11.1, 11.3, 11.5, 11.7, 11.9, 12.1, 12.3, 12.5, 12.7, 12.9,
                13.1, 13.3, 13.5, 13.7, 13.9],
            "n_pulsos": [
                9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300,
                9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320,
                9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360,
                9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380,
                9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9400,
                9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420,
                9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420,
                9420, 9440, 9460, 9480, 9500, 9520, 9540, 9560, 9580, 9600, 9620, 9640,
                9420, 9440, 9460, 9480, 9500, 9520, 9540, 9560, 9580, 9600, 9620, 9640,
                9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9642, 9645, 9646,
                9650, 9690, 9710, 9740, 9770, 9800, 9830, 9860, 9870, 9881, 9897, 9900, 9900, 9900,
                9902, 9905, 9908, 9902, 9900, 9905, 9908, 9912, 9915, 9918, 9920, 9922,
                9925, 9927, 9930, 9932, 9935, 9938, 9942, 9940, 9942, 9944, 9947, 9950,
                9952, 9955, 9958],
            "intervalo_caudal": [
                0.8, 0.9, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                4.1, 4.3, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9, 6.1, 6.3, 6.5, 6.7, 6.9,
                4.1, 4.3, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9, 6.1, 6.3, 6.5, 6.7, 6.9, 7.1, 7.3,
                7.5, 7.7, 7.9, 8.1, 8.3, 8.5, 8.7, 8.9, 9.1, 9.3, 9.5, 9.7, 9.9, 10.1, 10.3, 10.5,
                10.7, 10.9, 11.1, 11.3, 11.5, 11.7, 11.9, 12.1, 12.3, 12.5, 12.7, 12.9, 13.1, 13.3, 13.5,
                13.7, 13.9]
        }
    }
]

const contadoresData = [
    {
        "id": 3,
        "nombre": "Contador Maiz",
        "n_pulsos": 9958,
        "caudal": 0,
        "fecha_registro": "2024-02-17T11:41:08.000Z",
        "latitud": 39.868930,
        "longitud": -1.355572,
        "id_remote": "abcd06",
        "nombre_remote": "Remote Lite Maiz",
        "battery_level": 4020,
        "battery_timestamp": "2024-01-08 00:01:40",
        "real_value": 80.25,
        "historico": {
            "fecha_registro": [
                "2024-01-02 00:00:00",
                "2024-01-02 01:00:00",
                "2024-01-02 02:00:00",
                "2024-01-02 03:00:00",
                "2024-01-02 04:00:00",
                "2024-01-02 05:00:00",
                "2024-01-02 06:00:00",
                "2024-01-02 07:00:00",
                "2024-01-02 08:00:00",
                "2024-01-02 09:00:00",
                "2024-01-02 10:00:00",
                "2024-01-02 11:00:00",
                "2024-01-02 12:00:00",
                "2024-01-02 13:00:00",
                "2024-01-02 14:00:00",
                "2024-01-02 15:00:00",
                "2024-01-02 16:00:00",
                "2024-01-02 17:00:00",
                "2024-01-02 18:00:00",
                "2024-01-02 19:00:00",
                "2024-01-02 20:00:00",
                "2024-01-02 21:00:00",
                "2024-01-02 22:00:00",
                "2024-01-02 23:00:00",
                "2024-01-03 00:00:00",
                "2024-01-03 01:00:00",
                "2024-01-03 02:00:00",
                "2024-01-03 03:00:00",
                "2024-01-03 04:00:00",
                "2024-01-03 05:00:00",
                "2024-01-03 06:00:00",
                "2024-01-03 07:00:00",
                "2024-01-03 08:00:00",
                "2024-01-03 09:00:00",
                "2024-01-03 10:00:00",
                "2024-01-03 11:00:00",
                "2024-01-03 12:00:00",
                "2024-01-03 13:00:00",
                "2024-01-03 14:00:00",
                "2024-01-03 15:00:00",
                "2024-01-03 16:00:00",
                "2024-01-03 17:00:00",
                "2024-01-03 18:00:00",
                "2024-01-03 19:00:00",
                "2024-01-03 20:00:00",
                "2024-01-03 21:00:00",
                "2024-01-03 22:00:00",
                "2024-01-03 23:00:00",
                "2024-01-04 00:00:00",
                "2024-01-04 01:00:00",
                "2024-01-04 02:00:00",
                "2024-01-04 03:00:00",
                "2024-01-04 04:00:00",
                "2024-01-04 05:00:00",
                "2024-01-04 06:00:00",
                "2024-01-04 07:00:00",
                "2024-01-04 08:00:00",
                "2024-01-04 09:00:00",
                "2024-01-04 10:00:00",
                "2024-01-04 11:00:00",
                "2024-01-04 12:00:00",
                "2024-01-04 13:00:00",
                "2024-01-04 14:00:00",
                "2024-01-04 15:00:00",
                "2024-01-04 16:00:00",
                "2024-01-04 17:00:00",
                "2024-01-04 18:00:00",
                "2024-01-04 19:00:00",
                "2024-01-04 20:00:00",
                "2024-01-04 21:00:00",
                "2024-01-04 22:00:00",
                "2024-01-04 23:00:00",
                "2024-01-05 00:00:00",
                "2024-01-05 01:00:00",
                "2024-01-05 02:00:00",
                "2024-01-05 03:00:00",
                "2024-01-05 04:00:00",
                "2024-01-05 05:00:00",
                "2024-01-05 06:00:00",
                "2024-01-05 07:00:00",
                "2024-01-05 08:00:00",
                "2024-01-05 09:00:00",
                "2024-01-05 10:00:00",
                "2024-01-05 11:00:00",
                "2024-01-05 12:00:00",
                "2024-01-05 13:00:00",
                "2024-01-05 14:00:00",
                "2024-01-05 15:00:00",
                "2024-01-05 16:00:00",
                "2024-01-05 17:00:00",
                "2024-01-05 18:00:00",
                "2024-01-05 19:00:00",
                "2024-01-05 20:00:00",
                "2024-01-05 21:00:00",
                "2024-01-05 22:00:00",
                "2024-01-05 23:00:00",
                "2024-01-06 00:00:00",
                "2024-01-06 01:00:00",
                "2024-01-06 02:00:00",
                "2024-01-06 03:00:00",
                "2024-01-06 04:00:00",
                "2024-01-06 05:00:00",
                "2024-01-06 06:00:00",
                "2024-01-06 07:00:00",
                "2024-01-06 08:00:00",
                "2024-01-06 09:00:00",
                "2024-01-06 10:00:00",
                "2024-01-06 11:00:00",
                "2024-01-06 12:00:00",
                "2024-01-06 13:00:00",
                "2024-01-06 14:00:00",
                "2024-01-06 15:00:00",
                "2024-01-06 16:00:00",
                "2024-01-06 17:00:00",
                "2024-01-06 18:00:00",
                "2024-01-06 19:00:00",
                "2024-01-06 20:00:00",
                "2024-01-06 21:00:00",
                "2024-01-06 22:00:00",
                "2024-01-06 23:00:00",
                "2024-01-07 00:00:00",
                "2024-01-07 01:00:00",
                "2024-01-07 02:00:00",
                "2024-01-07 03:00:00",
                "2024-01-07 04:00:00",
                "2024-01-07 05:00:00",
                "2024-01-07 06:00:00",
                "2024-01-07 07:00:00",
                "2024-01-07 08:00:00",
                "2024-01-07 09:00:00",
                "2024-01-07 10:00:00",
                "2024-01-07 11:00:00",
                "2024-01-07 12:00:00",
                "2024-01-07 13:00:00",
                "2024-01-07 14:00:00",
                "2024-01-07 15:00:00",
                "2024-01-07 16:00:00",
                "2024-01-07 17:00:00",
                "2024-01-07 18:00:00",
                "2024-01-07 19:00:00",
                "2024-01-07 20:00:00",
                "2024-01-07 21:00:00",
                "2024-01-07 22:00:00",
                "2024-01-07 23:00:00",
                "2024-01-08 00:00:00",
                "2024-01-08 01:00:00",
                "2024-01-08 02:00:00",
                "2024-01-08 03:00:00",
                "2024-01-08 04:00:00",
                "2024-01-08 05:00:00",
                "2024-01-08 06:00:00",
                "2024-01-08 07:00:00",
                "2024-01-08 08:00:00",
                "2024-01-08 09:00:00",
                "2024-01-08 10:00:00",
                "2024-01-08 11:00:00",
                "2024-01-08 12:00:00",
                "2024-01-08 13:00:00",
                "2024-01-08 14:00:00",
                "2024-01-08 15:00:00",
                "2024-01-08 16:00:00",
                "2024-01-08 17:00:00",
                "2024-01-08 18:00:00",
                "2024-01-08 19:00:00",
                "2024-01-08 20:00:00",
                "2024-01-08 21:00:00",
                "2024-01-08 22:00:00",
                "2024-01-08 23:00:00",
                "2024-01-09 00:00:00",
                "2024-01-09 01:00:00",
                "2024-01-09 02:00:00",
                "2024-01-09 03:00:00",
                "2024-01-09 04:00:00",
                "2024-01-09 05:00:00",
                "2024-01-09 06:00:00",
                "2024-01-09 07:00:00",
                "2024-01-09 08:00:00",
                "2024-01-09 09:00:00",
                "2024-01-09 10:00:00",
                "2024-01-09 11:00:00"
            ],
            "caudal": [
                0.8, 0.9, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                4.1, 4.3, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9, 6.1, 6.3, 6.5, 6.7, 6.9,
                4.1, 4.3, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9, 6.1, 6.3, 6.5, 6.7, 6.9,
                7.1, 7.3, 7.5, 7.7, 7.9, 8.1, 8.3, 8.5, 8.7, 8.9, 9.1, 9.3, 9.5, 9.7, 9.9, 10.1,
                10.3, 10.5, 10.7, 10.9, 11.1, 11.3, 11.5, 11.7, 11.9, 12.1, 12.3, 12.5, 12.7, 12.9,
                13.1, 13.3, 13.5, 13.7, 13.9],
            "n_pulsos": [
                9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300,
                9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320,
                9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360,
                9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380,
                9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9400,
                9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420,
                9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420,
                9420, 9440, 9460, 9480, 9500, 9520, 9540, 9560, 9580, 9600, 9620, 9640,
                9420, 9440, 9460, 9480, 9500, 9520, 9540, 9560, 9580, 9600, 9620, 9640,
                9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9642, 9645, 9646,
                9650, 9690, 9710, 9740, 9770, 9800, 9830, 9860, 9870, 9881, 9897, 9900, 9900, 9900,
                9902, 9905, 9908, 9902, 9900, 9905, 9908, 9912, 9915, 9918, 9920, 9922,
                9925, 9927, 9930, 9932, 9935, 9938, 9942, 9940, 9942, 9944, 9947, 9950,
                9952, 9955, 9958],
            "intervalo_caudal": [
                0.8, 0.9, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                4.1, 4.3, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9, 6.1, 6.3, 6.5, 6.7, 6.9,
                4.1, 4.3, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9, 6.1, 6.3, 6.5, 6.7, 6.9, 7.1, 7.3,
                7.5, 7.7, 7.9, 8.1, 8.3, 8.5, 8.7, 8.9, 9.1, 9.3, 9.5, 9.7, 9.9, 10.1, 10.3, 10.5,
                10.7, 10.9, 11.1, 11.3, 11.5, 11.7, 11.9, 12.1, 12.3, 12.5, 12.7, 12.9, 13.1, 13.3, 13.5,
                13.7, 13.9]
        }
    },
    {
        "id": 5,
        "nombre": "Contador Almendros",
        "n_pulsos": 9958,
        "caudal": 0,
        "fecha_registro": "2024-01-10T11:41:08.000Z",
        "latitud": 39.864658,
        "longitud": -1.357314,
        "id_remote": "011B06",
        "nombre_remote": "Remote Lite Almendros",
        "battery_level": 3965,
        "battery_timestamp": "2023-10-02 13:55:40",
        "real_value": 11.4,
        "historico": {
            "fecha_registro": [
                "2024-01-02 00:00:00",
                "2024-01-02 01:00:00",
                "2024-01-02 02:00:00",
                "2024-01-02 03:00:00",
                "2024-01-02 04:00:00",
                "2024-01-02 05:00:00",
                "2024-01-02 06:00:00",
                "2024-01-02 07:00:00",
                "2024-01-02 08:00:00",
                "2024-01-02 09:00:00",
                "2024-01-02 10:00:00",
                "2024-01-02 11:00:00",
                "2024-01-02 12:00:00",
                "2024-01-02 13:00:00",
                "2024-01-02 14:00:00",
                "2024-01-02 15:00:00",
                "2024-01-02 16:00:00",
                "2024-01-02 17:00:00",
                "2024-01-02 18:00:00",
                "2024-01-02 19:00:00",
                "2024-01-02 20:00:00",
                "2024-01-02 21:00:00",
                "2024-01-02 22:00:00",
                "2024-01-02 23:00:00",
                "2024-01-03 00:00:00",
                "2024-01-03 01:00:00",
                "2024-01-03 02:00:00",
                "2024-01-03 03:00:00",
                "2024-01-03 04:00:00",
                "2024-01-03 05:00:00",
                "2024-01-03 06:00:00",
                "2024-01-03 07:00:00",
                "2024-01-03 08:00:00",
                "2024-01-03 09:00:00",
                "2024-01-03 10:00:00",
                "2024-01-03 11:00:00",
                "2024-01-03 12:00:00",
                "2024-01-03 13:00:00",
                "2024-01-03 14:00:00",
                "2024-01-03 15:00:00",
                "2024-01-03 16:00:00",
                "2024-01-03 17:00:00",
                "2024-01-03 18:00:00",
                "2024-01-03 19:00:00",
                "2024-01-03 20:00:00",
                "2024-01-03 21:00:00",
                "2024-01-03 22:00:00",
                "2024-01-03 23:00:00",
                "2024-01-04 00:00:00",
                "2024-01-04 01:00:00",
                "2024-01-04 02:00:00",
                "2024-01-04 03:00:00",
                "2024-01-04 04:00:00",
                "2024-01-04 05:00:00",
                "2024-01-04 06:00:00",
                "2024-01-04 07:00:00",
                "2024-01-04 08:00:00",
                "2024-01-04 09:00:00",
                "2024-01-04 10:00:00",
                "2024-01-04 11:00:00",
                "2024-01-04 12:00:00",
                "2024-01-04 13:00:00",
                "2024-01-04 14:00:00",
                "2024-01-04 15:00:00",
                "2024-01-04 16:00:00",
                "2024-01-04 17:00:00",
                "2024-01-04 18:00:00",
                "2024-01-04 19:00:00",
                "2024-01-04 20:00:00",
                "2024-01-04 21:00:00",
                "2024-01-04 22:00:00",
                "2024-01-04 23:00:00",
                "2024-01-05 00:00:00",
                "2024-01-05 01:00:00",
                "2024-01-05 02:00:00",
                "2024-01-05 03:00:00",
                "2024-01-05 04:00:00",
                "2024-01-05 05:00:00",
                "2024-01-05 06:00:00",
                "2024-01-05 07:00:00",
                "2024-01-05 08:00:00",
                "2024-01-05 09:00:00",
                "2024-01-05 10:00:00",
                "2024-01-05 11:00:00",
                "2024-01-05 12:00:00",
                "2024-01-05 13:00:00",
                "2024-01-05 14:00:00",
                "2024-01-05 15:00:00",
                "2024-01-05 16:00:00",
                "2024-01-05 17:00:00",
                "2024-01-05 18:00:00",
                "2024-01-05 19:00:00",
                "2024-01-05 20:00:00",
                "2024-01-05 21:00:00",
                "2024-01-05 22:00:00",
                "2024-01-05 23:00:00",
                "2024-01-06 00:00:00",
                "2024-01-06 01:00:00",
                "2024-01-06 02:00:00",
                "2024-01-06 03:00:00",
                "2024-01-06 04:00:00",
                "2024-01-06 05:00:00",
                "2024-01-06 06:00:00",
                "2024-01-06 07:00:00",
                "2024-01-06 08:00:00",
                "2024-01-06 09:00:00",
                "2024-01-06 10:00:00",
                "2024-01-06 11:00:00",
                "2024-01-06 12:00:00",
                "2024-01-06 13:00:00",
                "2024-01-06 14:00:00",
                "2024-01-06 15:00:00",
                "2024-01-06 16:00:00",
                "2024-01-06 17:00:00",
                "2024-01-06 18:00:00",
                "2024-01-06 19:00:00",
                "2024-01-06 20:00:00",
                "2024-01-06 21:00:00",
                "2024-01-06 22:00:00",
                "2024-01-06 23:00:00",
                "2024-01-07 00:00:00",
                "2024-01-07 01:00:00",
                "2024-01-07 02:00:00",
                "2024-01-07 03:00:00",
                "2024-01-07 04:00:00",
                "2024-01-07 05:00:00",
                "2024-01-07 06:00:00",
                "2024-01-07 07:00:00",
                "2024-01-07 08:00:00",
                "2024-01-07 09:00:00",
                "2024-01-07 10:00:00",
                "2024-01-07 11:00:00",
                "2024-01-07 12:00:00",
                "2024-01-07 13:00:00",
                "2024-01-07 14:00:00",
                "2024-01-07 15:00:00",
                "2024-01-07 16:00:00",
                "2024-01-07 17:00:00",
                "2024-01-07 18:00:00",
                "2024-01-07 19:00:00",
                "2024-01-07 20:00:00",
                "2024-01-07 21:00:00",
                "2024-01-07 22:00:00",
                "2024-01-07 23:00:00",
                "2024-01-08 00:00:00",
                "2024-01-08 01:00:00",
                "2024-01-08 02:00:00",
                "2024-01-08 03:00:00",
                "2024-01-08 04:00:00",
                "2024-01-08 05:00:00",
                "2024-01-08 06:00:00",
                "2024-01-08 07:00:00",
                "2024-01-08 08:00:00",
                "2024-01-08 09:00:00",
                "2024-01-08 10:00:00",
                "2024-01-08 11:00:00",
                "2024-01-08 12:00:00",
                "2024-01-08 13:00:00",
                "2024-01-08 14:00:00",
                "2024-01-08 15:00:00",
                "2024-01-08 16:00:00",
                "2024-01-08 17:00:00",
                "2024-01-08 18:00:00",
                "2024-01-08 19:00:00",
                "2024-01-08 20:00:00",
                "2024-01-08 21:00:00",
                "2024-01-08 22:00:00",
                "2024-01-08 23:00:00",
                "2024-01-09 00:00:00",
                "2024-01-09 01:00:00",
                "2024-01-09 02:00:00",
                "2024-01-09 03:00:00",
                "2024-01-09 04:00:00",
                "2024-01-09 05:00:00",
                "2024-01-09 06:00:00",
                "2024-01-09 07:00:00",
                "2024-01-09 08:00:00",
                "2024-01-09 09:00:00",
                "2024-01-09 10:00:00",
                "2024-01-09 11:00:00"
            ],
            "caudal": [
                0.8, 0.9, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                4.1, 4.3, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9, 6.1, 6.3, 6.5, 6.7, 6.9,
                4.1, 4.3, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9, 6.1, 6.3, 6.5, 6.7, 6.9,
                7.1, 7.3, 7.5, 7.7, 7.9, 8.1, 8.3, 8.5, 8.7, 8.9, 9.1, 9.3, 9.5, 9.7, 9.9, 10.1,
                10.3, 10.5, 10.7, 10.9, 11.1, 11.3, 11.5, 11.7, 11.9, 12.1, 12.3, 12.5, 12.7, 12.9,
                13.1, 13.3, 13.5, 13.7, 13.9],
            "n_pulsos": [
                9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300, 9300,
                9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320, 9320,
                9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360, 9360,
                9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380,
                9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9380, 9400,
                9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420,
                9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420, 9420,
                9420, 9440, 9460, 9480, 9500, 9520, 9540, 9560, 9580, 9600, 9620, 9640,
                9420, 9440, 9460, 9480, 9500, 9520, 9540, 9560, 9580, 9600, 9620, 9640,
                9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9640, 9642, 9645, 9646,
                9650, 9690, 9710, 9740, 9770, 9800, 9830, 9860, 9870, 9881, 9897, 9900, 9900, 9900,
                9902, 9905, 9908, 9902, 9900, 9905, 9908, 9912, 9915, 9918, 9920, 9922,
                9925, 9927, 9930, 9932, 9935, 9938, 9942, 9940, 9942, 9944, 9947, 9950,
                9952, 9955, 9958],
            "intervalo_caudal": [
                0.8, 0.9, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9, 0.8, 0.7, 0.6, 0.5, 0.9,
                4.1, 4.3, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9, 6.1, 6.3, 6.5, 6.7, 6.9,
                4.1, 4.3, 4.5, 4.7, 4.9, 5.1, 5.3, 5.5, 5.7, 5.9, 6.1, 6.3, 6.5, 6.7, 6.9, 7.1, 7.3,
                7.5, 7.7, 7.9, 8.1, 8.3, 8.5, 8.7, 8.9, 9.1, 9.3, 9.5, 9.7, 9.9, 10.1, 10.3, 10.5,
                10.7, 10.9, 11.1, 11.3, 11.5, 11.7, 11.9, 12.1, 12.3, 12.5, 12.7, 12.9, 13.1, 13.3, 13.5,
                13.7, 13.9]
        }
    },
]


module.exports = { contadoresData, getContadores }
